/* tslint:disable */
/* eslint-disable */

/**
 * 0 = UtilisationInterne
 * 1 = PeutEtreVendu
 */
export enum TypeArticle {
  UtilisationInterne = 0,
  PeutEtreVendu = 1
}
